import { render, staticRenderFns } from "./ModelsDeck.vue?vue&type=template&id=0b99a576&"
import script from "./ModelsDeck.vue?vue&type=script&lang=js&"
export * from "./ModelsDeck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports